import React, { Suspense, useRef } from 'react';
import { Canvas } from '@react-three/fiber';
import { OrbitControls, Stage, useGLTF } from '@react-three/drei';
import Loader from './Loader';
import { useGSAP } from '@gsap/react';
import gsap from 'gsap';

// Internal Model component to handle GLTF loading
const Model = () => {
    const { scene } = useGLTF('/models/snc1.glb');
    return <primitive object={scene} scale={3.5} position={[0, -1, 0]} />;
};

const TeamRobotCard = () => {
    const cardRef = useRef();

    useGSAP(() => {
        // Initial state
        gsap.set(cardRef.current, { opacity: 0, y: 20 });

        // Show the robot card when it enters the viewport
        gsap.to(cardRef.current, {
            opacity: 1,
            y: 0,
            duration: 0.8,
            ease: 'power2.out',
            scrollTrigger: {
                trigger: cardRef.current,
                start: 'top 85%',
                toggleActions: 'play none none reverse',
            }
        });
    }, []);

    return (
        <div ref={cardRef} className="flex flex-col items-center bg-gray-900/50 p-6 rounded-2xl backdrop-blur-sm border border-gray-800 w-[280px] h-[350px] relative overflow-hidden">
            <div className="w-full h-full flex flex-col items-center justify-center">
                <h3 className="text-xl font-bold text-white mb-1">SNC AI</h3>
                <p className="text-blue-400 text-sm font-medium mb-4">Core Intelligence</p>

                <div className="w-full h-48 cursor-grab active:cursor-grabbing">
                    <Canvas dpr={[1, 2]} camera={{ fov: 45 }} style={{ height: '100%', touchAction: 'pan-y' }}>
                        <Suspense fallback={null}>
                            <Stage environment="city" intensity={0.5}>
                                <Model />
                            </Stage>
                            <OrbitControls
                                enableZoom={false}
                                autoRotate
                                autoRotateSpeed={2}
                                enablePan={false}
                                minPolarAngle={Math.PI / 2}
                                maxPolarAngle={Math.PI / 2}
                            />
                        </Suspense>
                    </Canvas>
                </div>

                <div className="mt-4 text-center">
                    <span className="text-[10px] text-gray-500 uppercase tracking-widest">Always Active</span>
                </div>
            </div>
        </div>
    );
};

export default TeamRobotCard;
